import React from "react";
import moment from "moment";
import _ from "lodash";

const Status = (props) => {
    return (
        <div className="button-group" style={{ margin: ".5em 0", justifyContent: "space-between", alignItems: "center" }}>
            <div className="form-field" style={{ margin: "0 1em" }}>
                <label>
                    <b>Current Status</b> {_.startCase(props.state)}
                </label>
            </div>
            <div className="form-field" style={{ margin: "0 1em" }}>
                <label>
                    <b>Last Updated</b> {moment(props.updatedOn).format("h:mma MM/DD/YYYY")} ({props.updatedBy})
                </label>
            </div>
        </div>
    );
};

export default Status;
